import { string, struct } from 'io-ts/Decoder';

import { ChannelType } from './ChannelType';

export const RefItem = struct({
	id: string,
	name: string,
	channelType: ChannelType,
});
